exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-msg[data-v-2aa44867]{display:flex;margin-bottom:8px}.error-msg .error-icn[data-v-2aa44867]{width:20px;height:20px;background:tomato;color:#fff;display:block;border-radius:3px;text-align:center;line-height:20px;flex:none;margin-right:15px}.error-msg .error-txt[data-v-2aa44867]{color:tomato}.fade-enter-active[data-v-2aa44867],.fade-leave-active[data-v-2aa44867]{transition:opacity .3s}.fade-enter[data-v-2aa44867],.fade-leave-to[data-v-2aa44867]{opacity:0}", ""]);

// exports
